class GeneralRequest extends BaseForm {
    constructor(options) {
        super(options);

        this.fields = [
            {name: 'fname'},
            {name: 'lname'},
            {name: 'email', type: 'email'},
            {name: 'phone', type: 'phone'},
            {name: 'location'},
            {name: 'reason'},
            {name: 'responsetype'},
            {name: 'consent'},
            {name: 'photo_url', filetype: '.jpg,.jpeg,.png,.gif', filesize: 3000000, required: false},
        ];

        this.addDispatchListener();
    }

    addDispatchListener() {
        Me.dispatch.subscribe('form.initialized', this.addEventsOnForm, this);
    }

    addEvents(){
        super.addEvents();

        this.$phone.on('blur', (e)=>this.handlePhoneState(e));
        this.$email.on('blur', (e)=>this.handleEmailState(e));
    }

    addEventsOnForm(e, params){

        if(params.form ==  this.$el){
            this.$('#reason').on('change', (e) => this.reasonChangeHandler(e));
            this.$('#contact').on('change', (e) => this.contactChangeHandler(e));
            this.$('.single-rating').on('click', (e) => this.rateExperienceHandler(e));
            this.$('.single-rating').on('mouseenter', (e) => this.rateMouseEnterHandler(e));
            this.$('.ratings').on('mouseleave', (e) => this.rateMouseLeaveHandler(e));

            this.$('.fake-input').on('click', (e)=> this.fakeInputHandler(e));
            this.$('[type=file]').on('change', (e) => this.handleName(e));
        }

    }

    doTracking(){
        Me.track.event("Contact", "Submit");
        fbq('track', 'Contact');
    }

    contactChangeHandler(e) {
        this.form.removeField('email');
        this.form.removeField('phone');

        this.$('.variable-fields .field-row').each(function(index,value){
            if( $(value).attr('data-contact')){
                if( $(value).attr('data-contact').indexOf($(e.currentTarget).val()) != -1){
                    $(value).removeClass('hide');
                }else{
                    $(value).addClass('hide');
                }
            }
        });

        switch($(e.currentTarget).val()){
            case "1":
                this.form.addField({name: 'email', type: 'email'});
                break;
            case "2":
                this.form.addField({name: 'phone', type: 'phone'});
                break;
            case "3":
                break;
        }
    }

    handleName(e){
        let $input = $(e.currentTarget);
        let id = $input.attr('id');
        let $label = this.$('[for='+ id +']');
        let $fileName = $label.find('.file-name');

        let	name = ($input[0].files.length > 0) ? $input[0].files[0].name : $fileName.attr('data-placeholder');
        $fileName.html(name);
    }

    fakeInputHandler(e) {
        $(e.currentTarget).siblings('input').trigger('click');
    }

    rateExperienceHandler(e){
        this.$('.single-rating.selected').removeClass('selected');
        this.$('.single-rating').each(function(index,value){
            if(index == $(e.currentTarget).index()){
                $(value).addClass('active selected');
            }
            else if(index < $(e.currentTarget).index()){
                $(value).addClass('active');
            }else{
                $(value).removeClass('active');
            }
        });
    }

    rateMouseEnterHandler(e){
        this.$('.single-rating').each(function(index,value){
            if(index <= $(e.currentTarget).index()){
                $(value).addClass('hovered');
            }else{
                $(value).removeClass('hovered');
            }
        });
    }

    rateMouseLeaveHandler(e){
        this.$('.single-rating.hovered').removeClass('hovered');
    }

    reasonChangeHandler(e) {
        this.form.removeField('comment');
        this.form.removeField('date');
        this.form.removeField('time');
        this.form.removeField('rating');

        this.$('.variable-fields .field-row').each(function(index,value){

            $(value).find('.error').removeClass('error');

            if( $(value).attr('data-reason')){
                if( $(value).attr('data-reason').indexOf($(e.currentTarget).val()) != -1){
                    $(value).removeClass('hide');
                }else{
                    $(value).addClass('hide');
                }
            }
        });

        switch($(e.currentTarget).val()){
            case "1":
                this.form.addField({name: 'comment', required: true});
                break;
            case "2":
                this.form.addField({name: 'comment', required: true});
                this.form.addField({name: 'rating', required: true});
                this.form.addField({name: 'date', mask: '99-99-9999', required: true});
                this.form.addField({name: 'time', mask: '99:99', required: true});
                break;
            case "3":
                this.form.addField({name: 'comment', required: true});
                this.form.addField({name: 'rating', required: true});
                this.form.addField({name: 'date', mask: '99-99-9999', required: true});
                this.form.addField({name: 'time', mask: '99:99', required: true});
                break;
        }
    }
}
